import { RoleList } from '../constant/comment';
import { ROLE_ACCESS, TRoleAccess } from '../constant/storage';
import { ILessonCommentResponse } from '../interfaces/components/comment.interface';
import { ICommentDataMapping } from '../interfaces/hook.interface';
import { IPostEachCommentResponse } from '../interfaces/post.interface';

export const lessonCommentDataMapping = (
  comment: ILessonCommentResponse,
  commentSectionRole: TRoleAccess
): ICommentDataMapping => {
  return {
    commentInfo: {
      commentDate: comment.createdOn,
      content: comment.content,
      id: comment.id,
      isUpvoted: comment.isVoted,
      votes: comment.votes,
    },
    userInfo: {
      fullName: comment?.owner?.fullName,
      avatar: comment?.owner?.avatar,
      commentRole: comment.isAuthor ? RoleList.Author : RoleList.Member,
      commentSectionRole,
      isOwnerCommentAuthorPost: comment.isAuthorLesson
        ? ROLE_ACCESS.Owner
        : ROLE_ACCESS.Viewer,
      owner: {
        ownerId: `${comment.owner.ownerId}`,
        slug: comment.owner.slug,
      },
      hasBlueTick: comment.owner.hasBlueTick,
      academicRank: comment.owner.academicRank,
    },
  };
};

export const postCommentDataMapping = (
  comment: IPostEachCommentResponse,
  commentSectionRole: TRoleAccess
): ICommentDataMapping => {
  return {
    commentInfo: {
      commentDate: comment.createdOn,
      content: comment.content,
      id: comment.id,
      isUpvoted: comment.isVoted,
      votes: comment.votes,
    },
    userInfo: {
      fullName: comment?.owner?.fullName,
      avatar: comment?.owner?.avatar,
      commentRole: comment.isAuthor ? RoleList.Author : RoleList.Member,
      commentSectionRole,
      isOwnerCommentAuthorPost: comment.isAuthorPost
        ? ROLE_ACCESS.Owner
        : ROLE_ACCESS.Viewer,
      owner: {
        ownerId: `${comment.owner.ownerId}`,
        slug: comment.owner.slug,
      },
      hasBlueTick: comment.owner.hasBlueTick,
      academicRank: comment.owner.academicRank,
    },
  };
};
